import RequestService from 'services/request.service'

import { PlaygroupDeckDetailsResponse } from 'services/apiTypes/playgroupGG.types'

const BASE_URL = 'https://playgroup.gg/api/public/v1/'

const getUserFromUrl = async (userUrl: string) => {
  // eg: https://playgroup.gg/profiles/17230-michael

  const userId = userUrl.split('/profiles/')[1]?.split('-')[0]

  if (!userId) return Promise.reject('Unexpected Playgroup.gg profile URL')

  return RequestService.get(`${BASE_URL}/users/${userId}.json`, undefined, true)
}

const getDeckFromUrl = async (deckUrl: string) => {
  // eg: https://playgroup.gg/decks/75110-squirrels-and-tokens

  const deckId = deckUrl.split('/decks/')[1]?.split('-')[0]

  if (!deckId) return Promise.reject('Unexpected Playgroup.gg deck URL')

  return RequestService.get<PlaygroupDeckDetailsResponse>(`${BASE_URL}/decks/${deckId}.json`, undefined, true)
}

const PlaygroupGGService = {
  getUserFromUrl,
  getDeckFromUrl,
}

export default PlaygroupGGService
